import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

export const getTodaysTransactionsAmount = async () => {
    try {
        const today = new Date();
        today.setHours(0, 0, 0, 0);  // Set to start of today
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);  // Set to start of tomorrow

        const snapshot = await getDocs(collection(db, "transactions"));
        console.log(snapshot);
        const totals = {};
        
        snapshot.forEach(doc => {
            const data = doc.data();
            console.log(`Processing document ${doc.id}:`, {
                createdAt: data.createdAt,
                createdAtType: typeof data.createdAt,
                amountSender: data.amountSender,
                amountSenderType: typeof data.amountSender
            });
            
            // Check if createdAt field exists
            if (!data.createdAt) {
                console.warn(`Document ${doc.id} is missing createdAt field`);
                return; // Skip this document
            }
            
            // Handle Firestore Timestamp - it's automatically converted to Date object
            let transactionDate;
            
            if (data.createdAt instanceof Date) {
                // Already a Date object (converted from Firestore Timestamp)
                transactionDate = data.createdAt;
            } else if (data.createdAt && typeof data.createdAt.toDate === 'function') {
                // Firestore Timestamp object with toDate() method
                transactionDate = data.createdAt.toDate();
            } else if (typeof data.createdAt === 'string') {
                // String date - parse it
                const dateStr = data.createdAt.replace(/ UTC[+-]\d+/, '');
                transactionDate = new Date(dateStr);
            } else {
                console.warn(`Unsupported date format for document ${doc.id}:`, typeof data.createdAt, data.createdAt);
                return; // Skip this document
            }
            
            // Validate the parsed date
            if (!transactionDate || isNaN(transactionDate.getTime())) {
                console.warn(`Invalid date for document ${doc.id}:`, data.createdAt);
                return; // Skip this document
            }
            
            // Set to start of day for comparison
            const transactionDateStart = new Date(transactionDate);
            transactionDateStart.setHours(0, 0, 0, 0);

            // Check if transaction is from today
            if (transactionDateStart >= today && transactionDateStart < tomorrow) {
                // Fixed: use amountSender instead of amontSender
                const amount = parseFloat(data.amountSender);
                const currency = data.currencyCode || data.currency || 'USD';
                if (!isNaN(amount)) {
                    totals[currency] = (totals[currency] || 0) + amount;
                    console.log(`Added transaction: ${amount} ${currency} from ${data.createdAt}`);
                }
            }
        });

        console.log(`Total amount for today grouped:`, totals);
        return totals;
    } catch (error) {
        console.error("Error fetching today's transactions amount:", error);
        return {};
    }
};